<a class="link {{linkClass}}" *ngIf="!blankTarget"
   [ngClass]="{'disabled': disabled, 'link-wrap': wrap, 'display-inline-flex': inlineFlex, 'heading-5 no-margin break-word bold': mobileHeading, 'link-text-addition': textAddition}"
   (click)="emitClick(); $event.stopPropagation()">
  <ng-container [ngTemplateOutlet]="linkContentTemplate"></ng-container>
</a>
<a class="link {{linkClass}}" *ngIf="blankTarget"
   [ngClass]="{'disabled': disabled, 'link-wrap': wrap, 'display-inline-flex': inlineFlex, 'heading-5 no-margin break-word bold': mobileHeading, 'link-text-addition': textAddition}"
   [href]="link" target="_blank" (click)="$event.stopPropagation()">
  <ng-container [ngTemplateOutlet]="linkContentTemplate"></ng-container>
</a>
<ng-template #linkContentTemplate>
  <mat-icon class="svg-icon" *ngIf="icon" [svgIcon]="icon"></mat-icon>
  <span *ngIf="link?.toString().length">{{ link | translateValue }}</span>
  <mat-icon class="svg-icon" *ngIf="navigationIcon" [svgIcon]="'arrow_right'"></mat-icon>
</ng-template>
